import { Member } from 'Types/common.types';

export const updateJWT = (members: Member[], ownerEmail: string) => {
  const member = members.find(
    (member) => member?.user?.email !== '' && member?.user?.email === ownerEmail
  );

  return member?.user?.user_id ? member?.user?.user_id : '';
};
